import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IJobApplication, IJobApplicationState } from "./jobapplicationModel";
import { getAllJobApplication } from "./services/jobapplication.services";

const initialState: IJobApplicationState = {
  loading: false,
  error: "",
  JobApplicationID: null,
  JobApplicationList: [],
  FilterJobApplication: {
    JobTitle: "",
    FullName: "",
    EmailID: "",
    MobileNo: "",
    PositionTitle: "",
    PropertyName: "",
  },
};

const jobapplicationSlice = createSlice({
  name: "jobapplication",
  initialState,
  reducers: {
    setJobApplicationID: (state, action) => {
      state.JobApplicationID = action.payload;
    },
    clearJobApplicationID: (state) => {
      state.JobApplicationID = initialState.JobApplicationID;
    },
    setFilterJobApplication: (state, action) => {
      state.FilterJobApplication = action.payload;
    },
    clearFilterJobApplication: (state) => {
      state.FilterJobApplication = initialState.FilterJobApplication;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllJobApplication.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllJobApplication.fulfilled,
      (state, action: PayloadAction<IJobApplication[]>) => {
        state.loading = false;
        state.JobApplicationList = action.payload || [];
      },
    );
    builder.addCase(getAllJobApplication.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.JobApplicationList = [];
    });
  },
});

export const {
  clearJobApplicationID,
  setJobApplicationID,
  clearFilterJobApplication,
  setFilterJobApplication,
} = jobapplicationSlice.actions;
export default jobapplicationSlice.reducer;
